<div class="autocomplete-container">
  <kendo-textbox *ngIf="type == 'string'" (valueChange)="handleFilter($event)">
    <ng-template kendoPrefixTemplate>
      <button kendoButton fillMode="flat">
        <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
      </button>
    </ng-template>
  </kendo-textbox>

  <kendo-numerictextbox
    disableMouseWheel
    *ngIf="type == 'number'"
    (valueChange)="handleFilter($event)"
  >
    <ng-template kendoPrefixTemplate>
      <button kendoButton fillMode="flat">
        <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
      </button>
    </ng-template>
  </kendo-numerictextbox>
</div>

<div class="m-t-4">
  <kendo-checkbox
    #selectAll
    [checkedState]="allSelected"
    (change)="toggleSelectAll()"
  ></kendo-checkbox>
  <kendo-label [for]="selectAll">Select All</kendo-label>
</div>
<kendo-listview
  [height]="pageSize * 10"
  containerClass="k-d-flex k-flex-col k-flex-nowrap"
  (scrollBottom)="handleScroll()"
  [data]="selectableItems"
  class="m-t-2 m-l-4"
>
  <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
    <kendo-checkbox
      [checkedState]="dataItem.selected"
      (change)="toggleSelect(dataItem)"
    ></kendo-checkbox>
    <kendo-label>{{ dataItem.value }}</kendo-label>
  </ng-template>
</kendo-listview>
